import WizardStepPage from './WizardStepPage';

/** Step 1 — Trip overview (title, countries, images, etc.) */
const OverviewStep = (props) => (
    <WizardStepPage
        stepKey="overview"
        tripId={props.tripId}
        ensureTripId={props.ensureTripId}
        initialImageUrl={props.tripHeroImage}
        pendingImagePreviewUrl={props.pendingImagePreviewUrl}
        onPendingImageSelect={props.onPendingImageSelect}
        onPendingImageClear={props.onPendingImageClear}
        formData={props.formData?.overview}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        cityOptions={props.cityOptions}
        isCitiesLoading={props.isCitiesLoading}
        tripCurrency={props.tripCurrency}
        takenCountries={props.takenCountries}
    />
);

export default OverviewStep;
